import { Component, OnInit } from '@angular/core';
import { CreateTagDialogComponent } from '@ifa/create-tag-dialog/create-tag-dialog.component';
import { IfaTagDialogComponent } from '@root/components/ifa-list/ifa-tag-dialog/ifa-tag-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { IFAListService } from '@ifa/ifa-list.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import {PageEvent} from '@angular/material/paginator';
import { IFA } from '@ifa/ifa-list-container/ifa-list-container.model';
@Component({
  selector: 'app-ifa-list',
  templateUrl: './ifa-list.component.html',
  styleUrls: ['./ifa-list.component.scss'],
  providers: [IFAListService],
})
export class IfaListComponent implements OnInit {
  constructor(
    private ifaListService: IFAListService,
    private errorHandler: ErrorHandler,
    public dialog: MatDialog) {}

  public searchText: string;

  // MatPaginator Inputs
  public totalRecords : number;

  public pageSize = 20;
  
  public pageNumber:number = 0;

  ifaList: IFA[] = [];

  pageSizeOptions: number[] = [20, 50, 100, 500];

  public isLoading = false;

  ngOnInit() {
    this.readIFAList();
  }

  public readIFAList(query?:string) {
    const obj = {};
    this.isLoading = true;
    this.ifaListService.getIFAList(obj, this.pageNumber + 1, this.pageSize, query).subscribe(
      (response) => {
        if (response.status === 0) {
          this.ifaList = response.data.deviceDetails;
          this.totalRecords = response.data.totalRecords;
        }
        this.errorHandler.handleError(response);
        this.isLoading = false;
      },
      (error) => {
        this.errorHandler.handleError(error);
        this.isLoading = false;
      }
    );
  }

  public onIfaRefresh(){
    this.readIFAList();
  }

  public openCreateTagDialog() {
    const dialogRef = this.dialog.open(CreateTagDialogComponent, {
      width: '500px',
      data: {},
    });
  }

  public openDeleteTagDialog(mode) {
    const dialogRef = this.dialog.open(IfaTagDialogComponent, {
      width: '600px',
      data: { value: mode },
    });
  }

  public onPageChange(pageEvent: PageEvent){
    this.pageNumber = pageEvent.pageIndex;
    this.pageSize = pageEvent.pageSize;
    this.readIFAList();
  }

  public onChangeSearchInput(value: string){
    setTimeout(()=>{
      this.pageNumber =0;
      this.readIFAList(value);
    },1000)
  }

  public reset(value: string){
    if(!value){
      this.readIFAList();
    }
  }
}
